<template>
  <es-layout
    layout="{{['header', 'footer']}}"
    useDefaultNavbar="{{loadingPage || scrambling  ? false : true}}"
    navbarTitle="{{ navbarTitle}}"
    navbarStyle="{{navbarStyle}}"
    esMainStyle="{{esMainStyle}}"
    leftArrow="{{true}}"
    navbarClickLeft="{{goback}}"
    navbarUseRight
    bind:scrolling="pageScroll"
    useBlankPage="{{loadingPage || loadInitDataFail}}"
    blankPageType="{{ loadingPage ? 'category-loading' : loadInitDataFail ? 'blank-page' :''}}"
    blankContextSubTitle="{{loadFailText}}"
    loadingImageUrl="https://img-hxy021.didistatic.com/static/starimg/img/4Bn6domBsM1672373833796.png"
    categoryLoadingTitle="订火车票"
    categoryLoadingDesc="安心出行、轻松订"
    bind:blank-retry="retryTrainOrderDetailFunc"
    left="{{leftText}}"
  >
    <view slot="header" wx:if="{{scrambling}}">
      <es-navbar wx:style="{{navbarStyle}}" left-arrow="{{true}}" on-click-left="{{goback}}" custom-class="{{scrambleNavBar}}" customFillboxClass="{{scrambleFillBox}}">
        <view class="es-navbar-title">{{navbarTitle}}</view>
        <view slot='right'>
          <view class="es-navbar-right" bindtap="sideTitleJump">购票须知</view>
        </view>
      </es-navbar>
    </view>
    <error-card wx:if="{{showErrorView}}" errorMsg="{{errorMsg}}" />
    <block wx:else>
      <block slot="bg-icon" wx:if="{{isBeforeScrambled}}">
        <view class="scrambling-bg"></view>
      </block>
      <es-pull-down-refresh
        canPullDown="{{recordScrollHeight<5}}"
        isShowLoading="{{false}}"
        bind:refresh="init"
      >
        <!-- 订单状态及操作按钮-->
        <scrambling-order-head
          wx:if="{{scrambling}}"
          showProbability="{{!showPackAcc}}"
          serviceNoticeList="{{noticeList}}"
          bind:clickIndex="showTipsPop"
          bind:scantip="scanScramblingTip"
        />
        <order-state-head
          wx:else
          remainingTime="{{remainingTime}}"
          from="{{comeFrom}}"
          isChange="{{isChange}}"
          serviceNoticeList="{{noticeList}}"
          isSimplified="{{isSimplified}}"
          occupyConsultTime="{{occupy_consult_time}}"
          bind:clickIndex="showTipsPop"
        />
        <view
        >
          <view wx:class="{{bodyClass}}">
            <!-- 线下退改 -->
            <offline-refund orderId="{{baseInfo?.original_order_id}}" number="{{offlineRefundCount}}" />
            <accelerate-progress 
              wx:if="{{scrambling && showPackAcc}}" 
              wx:ref="accprogress"
              originalProgress="{{originalProgress}}"
              bind:packageUpdate="packageUpdate"
            />
            <block wx:if="{{isBeforeScrambled}}">
              <!-- 双通道抢票卡片 -->
              <dual-channel wx:if="{{scrambling}}" bind:showDetail="showAlternatePopup" style="margin-bottom: 9px" pageFrom="{{2}}" />
              <!-- 抢票信息 -->
              <scramble-info scrambling="{{scrambling}}"/>
            </block>
            <block wx:elif="{{isTransfer}}">
              <transfer-order-card
                orderList="{{orderList}}"
                bind:showSSI="showSSI"
              />
            </block>
            <block wx:else>
              <!-- 非抢票车次座席-->
              <order-info-list
                bind:click="showSSI"
                bind:operateTicket="handleTicketOperate"
                orderList="{{orderList}}"
                isChange="{{isChange}}"
                bind:refresh="refresh"
                from="{{comeFrom}}"
              />
            </block>
            <!-- 退改无忧服务权益bar -->
            <worry-free-cancellation-bar    
              wx:if="{{showWorryFreeCancelBar}}" 
              timing="{{1}}" 
              bindopenServiceDesc="showWorryFreeRightsDescDrawer"
            />
            <!-- 抢票身份信息 -->
            <!-- <block wx:if="{{isBeforeScrambled}}">
              <scramble-contact-person orderList="{{orderList}}"/>
            </block> -->
            <diamonds 
              class="diamonds" 
              style="marginBottom: 10px" 
              diamondsConf="{{diamondsConf}}" 
              bind:pageGoTo="pageGoTo" 
            />
            <!-- 头部费用-->
            <order-fee-head
              wx:if="{{!isSimplified || scrambling || showNewFee}}"
              bind:click="showDealDetail"
              customStyle="{{customStyle}}"
            />
            <train-rules /> 
            <view wx:for="{{components}}">
              <component
                is="{{item}}"
                customStyle="{{customStyle}}"
                content="{{otherInfo && otherInfo.reminder}}"
              />
            </view>
            <!-- 操作按钮 -->
            <view class="order-actions">
              <view
                wx:if="{{ canCancelOrder }}"
                class="action-btn"
                bindtap="cancelOrder"
              >取消{{ !isChange ? '订单' : '改签' }}</view>
              <view
                wx:if="{{ showIssuingBtn }}"
                class="action-btn disabled"
              >正在出票，不可取消</view>
              <view
                wx:if="{{ showLockBtn }}"
                class="action-btn disabled"
              >锁定座席中，不可取消</view>
              <view
                wx:if="{{ !isSimplified && !occupyingAndPayed && OccupationFailure }}"
                class="action-btn"
                bindtap="reschedule"
              >重新预订</view>
            </view>
          </view>
        </view>
      </view>
      </es-pull-down-refresh>
      <view
        slot="footer"
        class="order-footer"
        wx:class="{{{'order-footer-fixed': showDealAlert}}}"
        wx:if="{{ waitingPay || canPrepay}}"
      >
      <pay-bottom-bar
        showChangeTips="{{showChangeTips}}"
        canPay="{{canPay}}"
        bind:click="showDealDetail"
        bind:pay="beforeMakePay"
        showDealAlert="{{showDealAlert}}"
      />
      </view>
      <!-- 预付支持占座时展示 -->
      <view wx:if="{{prepayFooterVisible}}" slot="footer" class="order-footer prepay-footer">
        <view bindtap="onFooterPrepay" class="prepay-btn">提前支付，无需等待</view>
      </view>
      <view class="logo-wrap" wx:if="{{scrambling}}">
        <image src="{{logo}}" class="logo"/>
      </view>
    </block>
  </es-layout>
  <stay-info-drawer
    show="{{ showStayInfo }}"
    title="时刻表"
    stayInfo="{{stayInfo}}"
    bind:close="closeSSI"
  />

  <!-- 公告提示弹窗 -->
  <notice-popup
    show="{{ showNoticePop }}"
    info="{{notice}}"
    bindclose="hideDetailPop"
  />

  <!-- 占座预付弹窗 -->
  <prepay-popup wx:model="{{ prepayPopupVisible }}" bind:onAction="prepayAction" />

  <price-detail-info-alter
    show="{{showDealAlert}}"
    hasBottomBar="{{true}}"
    priceDetailCardTip="{{priceDetailCardTip}}"
    priceDetail="{{dealDetail}}"
    bind:close="hideDealDetail"
    title="{{priceDetailTitle}}"
  />
  <!-- 退票弹窗 -->
  <refund-explain
    show="{{isShowExplain}}"
    handlePrice="{{handlePrice}}"
    bind:confirmRefund="refund"
    bind:closeExplain="closeRefundExplain"
    selectTicket="{{selectTicket}}"
  />
  <!-- 权益说明弹窗 -->
  <worry-free-cancellation-drawer 
    hideFooter
    show="{{worryFreeDescDrawerVisiable}}"
    timing="{{1}}"
    bindclose="hideWorryFreeRightsDescDrawer"
  />

  <block wx:if="{{scrambling}}">
    <!-- 候补详情弹窗 -->
    <alternate-detail show="{{alternatePopupVisible}}" bind:close="closeAlternatePopup" />
    <!-- 抢票 取消挽留/解释 弹窗 -->
    <scrambling-explain 
      type="{{scramblingExplainType}}" 
      show="{{scramblingExplainVisible}}" 
      bind:close="closeScramblingExplain" 
      bind:confirm="confirmScramblingExplain" 
    />
    <!-- 加速包升级弹窗 -->
    <packages-popup 
      show="{{showPackagesPopup}}" 
      bind:close="triggerPackagesPopup"
      bind:refresh="payPackageRefresh"
    />
    <!-- 提速/助力成功弹窗 -->
    <feedback-popoup
      originalStatus="{{originalStatus}}"
      feebackFlag="{{feebackFlag}}"
     />
  </block>

  <ticket-operate-drawer 
    show="{{ticketOperateDrawerInfo.show}}" 
    operateType="{{ticketOperateDrawerInfo.type}}"
    initTicket="{{ticketOperateDrawerInfo.ticketId}}"
    initSegment="{{ticketOperateDrawerInfo.segmentId}}"
    bind:close="closeTicketOperate"
    bind:operateTicket="handleTicketOperate"
  />

  <es-dialog show="{{ showRefundErrorDialog }}" title="退票失败" bind:close="closeRefundErrorDialog" align="center">
    <view slot="content">
      {{ refundRrrmsg }}
    </view>
  </es-dialog>
  <es-dialog id="es-dialog"></es-dialog>
</template>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  /deep/ .scrambling-bg
    width 100%
    height 270px
    background: linear-gradient(85deg, #FFF5EE 7%, #E5F9F6 99%);
    position absolute
  /deep/ .scramble-navbar
    height 52px
  /deep/ .white-navbar
    background-color #fff
  /deep/ .white-fillbox
    position relative
    z-index 1
    background-color #fff
  .order-cancel
    background #ffffff
    border-radius 8px
    padding 14px 0px
    text-align center
    font-weight 600
    font-size 14px
    color $train-color-333
  .order-body
    padding 12px 12px 32px 12px
    min-height 50vh
    border-radius 16px 16px 0 0
    background-image linear-gradient(179deg, #FAFBFD 0%, #F0F1F4 6%, #F0F1F4 100%)
    .order-actions
      display flex
      align-items center
      justify-content space-between
      .action-btn
        height 48px
        flex 1
        border-radius 8px
        background-color #ffffff
        display flex
        align-items center
        justify-content center
        font-size 14px
        font-family PingFang SC
        font-weight 500
        color #333
        &.disabled
          color #999
        &+.action-btn
          margin-left 11px
    &.with-footer
      padding-bottom 130px
    &.with-tips
      padding-bottom 160px
    &.order-body-scrambling
      background-image none
      padding-top 0
    &.order-body-new
      background-image none
      padding-top 0
  .order-footer
    &.prepay-footer
      width 100%
      box-sizing border-box
      height 114px
      padding 16px 16px 0
      background #fff
      .prepay-btn
        background-color #FF7F41
        border-radius 8px
        color #fff
        height 48px
        display flex
        align-items center
        justify-content center
        font-size 16px
    &-fixed
      z-index 10001
  .logo-wrap
    display flex
    justify-content center
    padding-bottom calc(constant(safe-area-inset-bottom) + 32px)
    padding-bottom calc(env(safe-area-inset-bottom) + 32px)
    .logo
      width 238px
      height 42px
</style>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import initMixin from '@/mixins'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { getFinalPrice } from '@/utils/money'
  import { cancelOrder, makePay } from '@/api/order-detail/index'
  import { payment as payMgr } from '@/bridge'
  import { queryRefundTicketCost, refundTicket } from '@/api/refund-ticket/index'
  import { loadServiceNotice } from '@/api/train'
  import { isFastDoubleClick } from '@/utils/double-click'
  import {
  LOAD_FAIL_CONTENT,
  ORDERSTATUSINFO,
  isWXMini,
  isALIMini,
  FEE_DETAIL_TIPS,
  SLEEPER_SEAT_TYPE,
  isDdPassengerH5
} from '@/common/constant'
  import { formatDate, parseDate, compare } from '@/utils/baseDate'
  import { getTrainOrderDetail, getDealDetail } from '@/api/order-detail/index'
  import {
    STORAGE_SUCCESS_INFO,
    STORAGE_SELECT_TICKET,
    STORAGE_CHANGE_FAILED_INFO,
    SCRAMBLE_ACC_PRE_STATUS,
    SCRAMBLE_SPEED_PRE_STATUS
  } from '@/utils/train-storage'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { OrderStatus, TicketStatus } from '@/common/enum'
  import { simpleConfig, commonConfig, exemptionConfig } from './config'
  import { innerRouter, pagePath } from '@/common/jump'
  import { trackEvent } from '@/common/track'
  import { debounce, pageReload, jumpToDachePage } from '@/utils'
  import dayjs from 'dayjs'
  import { goback, is } from "@didi/spring-base"

  createPage({
    mixins: [initMixin],
    onLoad() {
      this.setTrainOrderDetail({})
      this.getPreAccProgress()
      this.getPreSpeedStatus()
    },
    onShow() {
      this.trackPageSw()
      setTimeout(this.init)
    },
    destroyed() {
      this.setChangeOrderInfo({})
      this.clearIntervalHandler()
    },
    data() {
      return {
        timer: null,
        requestTimer: null,
        waitPayTimer: null,
        remainingTime: undefined,
        isShowExplain: false,
        comeFrom: '',
        showRefundErrorDialog: false, // 退票失败弹窗
        refundRrrmsg: '',
        selectTicket: null,
        handlePrice: {},
        showErrorView: false,
        errorMsg: [],
        serviceNoticeList: [],
        showDealAlert: false,
        showStayInfo: false,
        showNoticePop: false,
        noticeIndex: 0, // 当前点击的公告index
        stayInfo: null, //时刻表
        loadInitDataFail: false,
        loadingPage: true,
        loadFailText: LOAD_FAIL_CONTENT,
        recordScrollHeight: 0, //记录滑动的高度
        dealDetail: {},
        prepayPopupVisible: false,
        prepayFooterVisible: false,
        prepayHandleTimes: 0,
        logo:"https://ut-static.udache.com/webx/sfc/0SK3xlrrmGWbdROKh8eI-.png",
        errLoginStatusArr: ['7503','7504','7505','7506','7507','7508','7509','7510','231014','8000'], // 需要重新登录
        alternatePopupVisible: false,
        scramblingExplainVisible: false,
        scramblingExplainType: '',
        operateType: 'change',
        originalProgress: 0,
        worryFreeDescDrawerVisiable: false, // 退改无忧权益说明弹窗
        showPackagesPopup: false, //付费升级抢票加速包弹层
        showSuccessPopup: true, //助力｜升级成功弹窗
        originalStatus: 0,
        feebackFlag:false
      }
    },
    computed: {
      ...store.mapState({
        baseInfo: 'order.base_info', // 订单信息
        otherInfo: 'order.other_info', //其他信息
        orderList: 'order.order_list',
        feeInfo: 'order.fee_info', // 费用明细
        couponInfo: 'order.coupon_info', // 费用明细
        state: 'order.base_info.status', // 订单状态
        occupy_consult_time: 'order.base_info.occupy_consult_time', // 占座倒计时
        statusName: 'order.base_info.status_name', // 订单准确状态（中文）
        timeSequence: 'order.time_sequence', //时间线
        ticketInfo: 'order.ticketInfo', // 订单火车票信息
        token: 'user.token',
        offlineRefundInfo: 'order.offline_refund_info', // 线下退信息
        scrambleTicketInfo: 'order.scramble_ticket_info', //抢票信息
        packageInfo: 'order.package_info', // 订单详情加速包模块信息
        ticketOperateDrawerInfo:'order.tikcet_operate_drawer_info',
        extension: 'order.base_info.extension'
      }),
      trackEventPublicParams() {
        const { order_id } = this.$mpxRoute.query || {}
        return {
          order_id,
          status: this.orderStatus,
          login_type: this.baseInfo?.order_type === 1 ? 'quick' : '12306'
        }
      },
      order_type(){
        return this.baseInfo.order_type
      },
      isBeforeScrambled(){
        return this.order_type === 2 && (
          [ OrderStatus.SCRAMBLE_BOOKING, 
            OrderStatus.SCRAMBLING, 
            OrderStatus.SCRAMBLE_FAILURE,
            OrderStatus.REFUNDING,
            OrderStatus.CLOSED,
            OrderStatus.SCRAMBLE_CANCELLING,
            OrderStatus.REISSUE].includes(this.state)
        )
      },
      scrambling(){
        return [OrderStatus.SCRAMBLING].includes(this.state) && this.order_type === 2
      },
      occupy(){
        return [OrderStatus.OCCUPYING_SEAT,OrderStatus.ISSUING].includes(this.state) && this.order_type === 0
      },
      showNewFee(){
        return [OrderStatus.ISSUING].includes(this.state) && this.order_type === 0
      },
      leftText() {
        const { from } = this.$mpxRoute.query || {}
        return (isWXMini || isALIMini) && from === 'home' ? '首页' : ''
      },
      bodyClass() {
        return {
          'order-body': true,
          'with-footer': (this.waitingPay && !this.showChangeTips) || this.prepayFooterVisible,
          'with-tips': this.waitingPay && this.showChangeTips,
          'order-body-scrambling':this.scrambling,
          'order-body-new':true 
        }
      },
      offlineRefundCount() {
        return this.offlineRefundInfo?.status === 1 ? this.offlineRefundInfo?.count : 0
      },
      orderStatus() {
        // 后端给的枚举映射有问题 暂时给中文
        // return Object.keys(OrderStatus).find(k => OrderStatus[k] === this.state)
        return this.baseInfo.status_name
      },
      canPay() {
        return !!this.remainingTime && (this.waitingPay || this.canPrepay)
      },
      isSimplified() {
        let _flag1 = [
          OrderStatus.BOOKING,
          OrderStatus.OCCUPYING_SEAT,
          OrderStatus.CHANGE_OCCUPYING_SEAT,
          OrderStatus.SCRAMBLE_BOOKING
        ].includes(this.state) && this.baseInfo?.is_pay !== 1
        let _flag2 = [
          OrderStatus.SCRAMBLING,
        ].includes(this.state)
        return _flag1 || _flag2
      },
      // 占座已支付
      occupyingAndPayed() {
        return [
          OrderStatus.OCCUPYING_SEAT,
          OrderStatus.CHANGE_OCCUPYING_SEAT
        ].includes(this.state) && this.baseInfo?.is_pay === 1
      },
      // occupyingAndPrepay() {
      //   return [
      //     OrderStatus.OCCUPYING_SEAT,
      //     // OrderStatus.CHANGE_OCCUPYING_SEAT
      //   ].includes(this.state) && this.baseInfo?.is_pay === 1
      // },
      // 占座失败
      OccupationFailure() {
        return this.state === OrderStatus.REFUNDING
      },
      noticeList() {
        return this.isSimplified && this.baseInfo.order_type !== 1 ? [] : this.serviceNoticeList
      },
      esMainStyle() {
        if(this.loadingPage){
          return { background: '#f0f1f4'}
        }
        if(this.scrambling){
          return {}
        }
        return {background: '#f2f6f9'}
      },
      navbarTitle() {
        return this.waitingPay && !this.isChange
          ? '支付订单'
          : this.waitingPay && this.isChange
          ? '改签'
          :this.scrambling
          ? '抢票订单'
          : this.showErrorView
          ? ''
          : '订单详情'
      },
      //待支付
      waitingPay() {
        return (this.state === OrderStatus.BOOKING || this.state === OrderStatus.SCRAMBLE_BOOKING) && this.baseInfo?.is_pay !== 1
      },
      // 可以取消订单
      canCancelOrder() {
        return (
          this.waitingPay ||
          (this.state === OrderStatus.PAID && this.baseInfo?.order_type === 1) ||
          ((this.state === OrderStatus.SCRAMBLE_BOOKING ||
            this.state === OrderStatus.SCRAMBLING) &&
            this.baseInfo?.order_type === 2)
        )
      },
      // 免登购票，锁定坐席不可取消按钮展示
      showIssuingBtn() {
        const _flag1 = this.state === OrderStatus.ISSUING && this.baseInfo?.order_type === 0
        const _flag2 = this.state === OrderStatus.ISSUING && this.baseInfo?.order_type === 1
        return _flag1 || _flag2
      },
      showLockBtn() {
        return this.state === OrderStatus.ISSUING && this.baseInfo?.order_type === 2
      },
      // 可以占座预付
      canPrepay() {
        // 占座中 可以预付 未支付
        return ([
            OrderStatus.OCCUPYING_SEAT,
            OrderStatus.CHANGE_OCCUPYING_SEAT,
          ].includes(this.state)
          && this.baseInfo?.occupy_consult_time > 0
          && this.baseInfo?.can_pre_pay === 1
          && this.baseInfo?.is_pay !== 1) || this.isExemptionBooking || this.isScrambleBooking
      },
      // 是否为免登未支付
      isScrambleBooking() {
        return (
          this.state === OrderStatus.SCRAMBLE_BOOKING &&
          this.baseInfo?.can_pre_pay === 1 &&
          this.baseInfo?.is_pay !== 1 &&
          this.baseInfo.consult_time > 0
        )
      },
      // 是否为免登未支付
      isExemptionBooking() {
        return (
          this.state === OrderStatus.BOOKING &&
          this.baseInfo?.can_pre_pay === 1 &&
          this.baseInfo?.is_pay !== 1 &&
          this.baseInfo?.order_type === 1 &&
          this.baseInfo.consult_time > 0
        )
      },
      //原始订单id
      originalOrderId() {
        return this.baseInfo?.original_order_id
      },
      goback() {
        const { from } = this.$mpxRoute.query || {}
        return () => {
          trackEvent('userteam_train_orderdetail_return_ck', 'UT-火车票-订单详情-返回-点击', {
            ...this.trackEventPublicParams,
          })
          if (from === 'home') {
            innerRouter.replace(pagePath().HOME) //返回首页
          } else {
            goback()
          }
        }
      },
      components() {
        return this.isSimplified ? this.baseInfo.order_type === 1 ? exemptionConfig : simpleConfig : commonConfig
      },
      navbarStyle() {
        return {
          color: '#333',
          'font-size': '18px',
          'font-weight': 600,
          background: this.showErrorView ? '#F3F4F5' : this.scrambling ? '' :'#fff',
          'font-family': 'PingFangSC'
        }
      },
      customStyle() {
        return {
          margin: '0px 0px 10px'
        }
      },
      //改签只能一次改签一个车，因此根据这个判断是否改签
      isChange() {
        return [23, 24].includes(this.baseInfo.status) || this.baseInfo.status_name === '改签待支付'
      },
      isTransfer() {
        return this.baseInfo.union_journey
      },
      priceDetailTitle() {
        return this.waitingPay ? '费用明细' : '交易记录'
      },
      showChangeTips() {
        return this.waitingPay && this.isChange
      },
      reverseOrderProgress() {
        const arr = this.orderProgress?.slice?.(0)
        return arr?.reverse?.() || []
      },
      price() {
        return getFinalPrice(this.feeInfo?.total_price ?? 0)
      },
      // 公告弹窗信息
      notice() {
        return this.noticeIndex < this.serviceNoticeList?.length
          ? this.serviceNoticeList[this.noticeIndex]
          : {}
      },
      // 免登录购票如果有学生票或者卧铺需要展示明细提示
      hasStudentOrIsSleeperType() {
        const allTickets = this.orderList?.reduce((ret, cur) => ret.concat(cur.tickets_info), [])
        // 下单后的旅客类型 1成人 2儿童 3学生 4残军
        const _hasStudent = allTickets.find(({ticket_type}) => ticket_type === '3') ? 1 : 0
        const _isSleeperType = allTickets.find(({seat_type_code}) => SLEEPER_SEAT_TYPE.includes(seat_type_code)) ? 1 : 0
        return `${_isSleeperType},${_hasStudent}`
      },
      // 免登下单的待支付提示
      priceDetailCardTip() {
        if(this.baseInfo?.order_type === 2) {
          return '按所选坐席中最高金额收取，出票后返还差价'
        }
        if(this.baseInfo?.order_type !== 1 || !this.waitingPay) return ''
        return FEE_DETAIL_TIPS[this.hasStudentOrIsSleeperType]
      },
      scrambleNavBar() {
        let _class = ''
        if(!this.scrambling) _class += 'white-navbar'
        if(this.scrambling) _class += 'scramble-navbar'
        if(this.scrambling && this.recordScrollHeight > 5) _class += ' white-navbar'
        return _class
      },
      scrambleFillBox() {
        let _class = ''
        if(!this.scrambling) _class += 'white-fillbox'
        if(this.scrambling && this.recordScrollHeight > 5) _class += 'white-fillbox'
        return _class
      },
      // 金刚位配置
      diamondsConf() {
        const { appid } = this.$mpxRoute.query || {}
        return [
          {
            type: 'rent',
            text: '租车',
            icon:
              'https://ut-static.udache.com/webx/sfc/H1I_46TZZXhrsjaIsj5IK.png',
            hide: ['121735', '2021004166617541'].includes(appid)
          },
          {
            type: 'taxi',
            text: '打车',
            icon:
              'https://ut-static.udache.com/webx/sfc/MrW4BkikEECZQMJh7lP6m.png',
            hide: is('harmonyos') || ['121735', '2021004166617541'].includes(appid)
          },
          {
            type: 'customer',
            text: '联系客服',
            icon:
              'https://ut-static.udache.com/webx/sfc/WkQap-DxD5m-ewCKtemSO_33.png',
          } 
        ]
      },
      showPackAcc() {
        return this.packageInfo && Object.keys(this.packageInfo).length > 0
      },
      // 服务类型
      orderServiceType() {
        return this.extension ? +JSON.parse(this.extension).serviceType : 3
      },
      // 退改无忧bar 展示节点：占座中、待支付、出票成功、已退票赚取金额不为0
      showWorryFreeCancelBar() {
        const showStatusArr = ['占座中', '待支付', '已出票']
        const refundStatusArr = ['已退票', '部分退票', '退票中']
        const case1 =
          this.orderServiceType === 2 && showStatusArr.some((item) => this.orderStatus.includes(item))
        const case2 =
          this.orderServiceType === 2 &&
          refundStatusArr.some((item) => item === this.orderStatus) &&
          this.baseInfo?.totalDiscountHandFee > 0
        return case1 || case2
      }
    },
    watch: {
      // state: {
      //   handler(newVal, oldVal) {
      //     if (newVal) {
      //       // 预存可能会改签失败时要展示的订单信息
      //       if (newVal === OrderStatus.CHANGE_OCCUPYING_SEAT) {
      //         this.setChangeFailedOrderInfo({
      //           ...(this.orderList?.[0] || {})
      //         })
      //       }
      //       // 改签占座中 => 非待支付 判定为改签失败
      //       if (oldVal === OrderStatus.CHANGE_OCCUPYING_SEAT && newVal !== OrderStatus.BOOKING) {
      //         const changeFailedOrder = getStorage(STORAGE_CHANGE_FAILED_INFO)
      //         if (changeFailedOrder?.order_id === this.baseInfo?.order_id) {
      //           innerRouter.push(pagePath().OCCUPYFAILED)
      //         }
      //       }
      //     }
      //   }
      // },
      'baseInfo.status_name': {
        handler(newVal, oldVal) {
          newVal && this.trackPageSw()
        }
      },
      canPrepay: {
        handler(newVal, oldVal) {
          if(!oldVal && newVal && !this.prepayHandleTimes) {
            this.prepayHandleTimes++
            this.onPrepay()
          }
          // if(newVal) {
          //   setTimeout(() => {
          //     this.closeSSI()
          //     this.prepayPopupVisible = this.canPrepay
          //   }, 3000)
          // }else {
          //   this.prepayPopupVisible = this.prepayFooterVisible = false
          // }
        }
      },
      prepayPopupVisible: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.trackPrepayPopup({
              event_id: 'userteam_train_concancel_paypop_sw',
              event_name: 'UT-火车票-订单详情页-支付弹窗-曝光'
            })
          }
        }
      },
    },
    methods: {
      ...store.mapMutations({
        setSupplierId: 'train.setSupplierId',
        setTrainOrderDetail: 'order.setTrainOrderDetail',
        setChangeOrderInfo: 'change.setChangeOrderInfo',
        setChangeFailedOrderInfo: 'change.setChangeFailedOrderInfo',
        setTravelDate: 'travel.setTravelDate',
        changeSelectCityList: 'travel.changeSelectCityList',
        setTikcetOperateDrawerStatus: 'order.setTikcetOperateDrawerStatus'
      }),
      // 埋点
      trackToPay(module) {
        trackEvent('userteam_train_orderdetail_topay_ck', 'UT-火车票-订单详情-待支付-点击', {
          ...this.trackEventPublicParams,
          module,
          type: this.isChange ? 'modify' : 'order'
        })
      },
      // 重新预订
      reschedule() {
        const { order_id } = this.$mpxRoute.query || {}
        const {
          start_time,
          from_city_id,
          from_station_name,
          to_city_id,
          to_station_name
        } = this.orderList?.[0] || {}
        // 日期限制
        const _t = compare(parseDate(start_time), new Date()) >= 0 ? parseDate(start_time) : new Date()
        this.trackIssuedCk({
          module: 'reorder',
          order_id,
          ticket_id: '',
          status: this.baseInfo.status_name
        })
        this.setTravelDate(_t.getTime())
        this.changeSelectCityList({ // 初始到达站
          type: 'currentFromCity',
          data: {
            id: from_city_id,
            name: from_station_name,
            subName: from_station_name,
            precise_search: '0',
          }
        })
        this.changeSelectCityList({ // 初始到达站
          type: 'currentToCity',
          data: {
            id: to_city_id,
            name: to_station_name,
            subName: to_station_name,
            precise_search: '0',
          }
        })
        innerRouter.replace(pagePath().HOME)
      },
      // 预付弹窗埋点
      trackPrepayPopup({ event_id, event_name, params={} }) {
        trackEvent(event_id, event_name, {
          ...this.trackEventPublicParams,
          ...params,
          type: this.isChange ? 'modify' : 'order',
          login_type: this.baseInfo?.order_type === 1 ? 'quick' : '12306'
        })
      },
      trackIssuedCk(params) {
        // @module
        // return：我要退票
        // modify：我要改签
        // cus_service：联系客服
        // pickup：送站
        // meet：接站
        // reorder: 重新预订
        trackEvent('userteam_train_orderdetail_issued_ck', 'UT-火车票-订单详情-已出票-点击', {
          ...this.trackEventPublicParams,
          ...params
        })
      },
      trackPageSw() {
        if (this.orderStatus) {
          trackEvent('userteam_train_orderdetail_sw', 'UT-火车票-订单详情-曝光', {
            ...this.trackEventPublicParams,
          })
        }
      },
      sideTitleJump(){
        innerRouter.push(pagePath().ICKETPURCHASENOTICE)
      },
      clearIntervalHandler() {
        this.timer && clearTimeout(this.timer)
        this.requestTimer && clearTimeout(this.requestTimer)
        this.waitPayTimer && clearTimeout(this.waitPayTimer)
        this.timer = this.requestTimer = this.waitPayTimer = null
        this.remainingTime = undefined
      },
      refresh() {
        this.$forceUpdate()
      },
      retryTrainOrderDetailFunc() {
        this.loadingPage = true
        this.fetchTrainOrderDetailFunc()
      },
      // 支付倒计时
      async updateEndTime(endTime) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        // 占座已付款 刷新 等出票
        if(this.state === OrderStatus.BOOKING && this.baseInfo?.is_pay === 1) {
          this.timer = setTimeout(() => this.init(), 1000)
          return
        }
        if (endTime <= 0) {
          this.remainingTime = 0
          // 关闭订单
          await this.init()
          this.checkIsOrderClose()
          return
        }
        this.remainingTime = endTime
        this.timer = setTimeout(() => this.updateEndTime(--endTime), 1000)
      },
      // 兜底后端关单延迟
      checkIsOrderClose() {
        if (this.waitPayTimer) {
          clearTimeout(this.waitPayTimer)
          this.waitPayTimer = null
        }
        if (this.baseInfo?.consult_time === 0 && this.state === OrderStatus.BOOKING) {
          this.waitPayTimer = setTimeout(async () => {
            await this.init()
            this.checkIsOrderClose()
          }, 1500)
        }
      },
      async init() {
        this.comeFrom = this.$mpxRoute.query?.from
        this.clearIntervalHandler()
        await this.fetchTrainOrderDetailFunc()
        this.occupiedSeatHandler()
      },
      // 查询订单详情
      async fetchTrainOrderDetailFunc(silenceLoading) {
        const { order_id } = this.$mpxRoute.query
        let params = {
          order_id,
          query_type: '1,2,3',
          is_need_reminder: '1',
          is_format_order_time: '1',
          scene_type: 1 // 场景类型，1 - 订单详情，2 - 退票页面，3 - 改签页面
        }

        await getTrainOrderDetail(params)
          .then(({ data, success, message, code }) => {
            if (success) {
              if (code === '0') {
                this.showErrorView = false
                this.setTrainOrderDetail({ ...data })
                this.mainApiErrorHandler()
                this.remainingTime = (OrderStatus.BOOKING === this.state || OrderStatus.SCRAMBLE_BOOKING === this.state)
                  ? this.baseInfo?.consult_time
                  : [OrderStatus.OCCUPYING_SEAT, OrderStatus.CHANGE_OCCUPYING_SEAT].includes(this.state)
                    ? this.baseInfo?.occupy_consult_time
                    : undefined
                if (this.remainingTime > 0) {
                  this.updateEndTime(this.remainingTime)
                }
                if (!this.serviceNoticeList?.length) {
                  this.getServiceNotice()
                }
              } else if (code == '2032') {
                this.mainApiErrorHandler()
                this.errorMsg = ['无效的订单', '请联系系统管理员获得帮助']
                this.showErrorView = true
              } else {
                this.showErrorView = false
                if (silenceLoading != true) {
                  this.mainApiErrorHandler()
                  this.showRequestErrorToast(message)
                }
              }
            } else {
              this.showErrorView = false
              if (!silenceLoading) {
                this.setTrainOrderDetail({})
                this.mainApiErrorHandler()
                this.loadFailText = LOAD_FAIL_CONTENT
              }
            }
          })
          .catch((e) => {
            //这块需要加一个前端的监控
            this.mainApiErrorHandler()
            this.loadFailText = LOAD_FAIL_CONTENT
          })
          .finally(() => {
            this.loadingPage = false
          })
      },
      // 主接口出错处理
      mainApiErrorHandler() {
        this.loadInitDataFail = !this.originalOrderId
      },
      // 状态为 [3已支付待出票][21占座][22出票中][23改签占座中] 时,需要轮询接口
      async occupiedSeatHandler(silenceLoading = true) {
        const { order_id } = this.$mpxRoute.query || {}
        const needUpdate = [
          OrderStatus.PAID,
          OrderStatus.OCCUPYING_SEAT,
          OrderStatus.ISSUING,
          OrderStatus.CHANGE_OCCUPYING_SEAT,
          OrderStatus.SCRAMBLING,
          OrderStatus.SCRAMBLE_CANCELLING,
        ].includes(this.state)
        this.requestTimer && clearTimeout(this.requestTimer)
        if (needUpdate && this.originalOrderId === order_id) {
          this.requestTimer = setTimeout(async () => {
            await this.fetchTrainOrderDetailFunc(silenceLoading)
            this.occupiedSeatHandler()
          }, 5000)
        }
      },
      // 处理退票 改签
      handleTicketOperate({ detail }) {
        const { type, ticket, order } = detail
        this.trackIssuedCk({
          module: type === 'change' ? 'modify' : 'return',
          order_id: order.order_id,
          ticket_id: JSON.stringify(ticket.map(ticket => ticket.ticket_id)),
          status: this.orderStatus
        })
        const ticketStatus = ticket.map(ticket => ticket.status)
        if (ticketStatus.includes(TicketStatus.OFFLINE_REISSUE)) {
          Dialog.alert({
            title: '温馨提示',
            message: '暂不支持已线下改签的车票退票，请到原改签渠道申请退票',
            confirmButtonText: '知道了',
            confirm: () => {}
          })
          return
        }
        switch (type) {
          case 'change':
            this.changeTicket(ticket, order)
            break
          case 'refund':
            this.refundTicketCost(ticket, order)
            break
          default:
            break
        }
      },
      // 改签
      changeTicket(ticket, order) {
        const changeOrderInfo = {
          supplier_order_id: ticket.supplier_order_id,
          contact_phone: this.baseInfo?.contact_phone,
          order_id: order.order_id,
          ticket_id: ticket.map(item=>item.ticket_id),
          select_order: order,
          select_ticket: ticket,
          order_type: this.baseInfo.union_journey
        }
        this.baseInfo.supplier_id && this.setSupplierId(this.baseInfo.supplier_id)
        this.setChangeOrderInfo(changeOrderInfo)
        innerRouter.push(pagePath().CHANGETICKETPAGE, {
          from: this.comeFrom
        })
      },
      // 查询退票信息
      refundTicketCost(ticket, order) {
        // 存储退票结果页信息
        this.setSuccessPageInfo(order, ticket)
        const params = {
          from_city_id: order.from_city_id,
          from_station_name: order.from_station_name,
          to_city_id: order.to_city_id,
          to_station_name: order.to_station_name,
          order_id: ticket[0]?.order_id,
          refund_type: 1,
          refund_info: JSON.stringify(
            ticket.map(item =>{
              return {
                ticket_id: item?.ticket_id,
                personal_pay: item?.personal_pay,
                departure_time: item?.start_time,
                cross_border: item?.cross_border
              }
            })
          )
        }
        queryRefundTicketCost(params).then(({ data, success, code, message }) => {
          if (success) {
            if (code === '0') {
              const { estimate_refund_detail, handing_fee_detail, coupon_amount, festival_refund_rule_limit_show, discount_handing_fee, coupon_name } = data || {}
              this.handlePrice = {
                coupon_name, // 优惠券名称
                coupon_amount, // 优惠券
                total_price: estimate_refund_detail?.total_price, // 车票
                total_refund: estimate_refund_detail?.total_refund, // 退款金额
                total_handing_fee: estimate_refund_detail?.total_handing_fee, // 手续费
                handing_fee_detail: handing_fee_detail,
                festival_refund_rule_limit_show,
                discount_handing_fee
              }
              this.isShowExplain = true
              ticket.forEach(item =>{
                  trackEvent(
                  'userteam_train_orderdetail_canpop_sw',
                  'UT-火车票-订单详情页-退票弹窗-曝光',
                  {
                    status: this.orderStatus,
                    order_id: item?.order_id,
                    ticket_id: item?.ticket_id,
                    login_type: this.baseInfo?.order_type === 1 ? 'quick' : '12306'
                  }
                )
              })
            } else if (code === '4008') {
              Dialog.alert({
                title: '温馨提示',
                message,
                confirmButtonText: '知道了',
                confirm: () => {}
              })
            } else {
              Dialog.alert({
                message,
                confirmButtonText: '我知道了',
                confirm: () => {}
              })
            }
          } else {
            this.showRequestErrorToast()
          }
        })
      },
      // 关闭退票费用明细弹窗
      closeRefundExplain() {
        this.isShowExplain = false
      },
      // 确认退票
      refund() {
        const params = {
          supplier_order_id: this.selectTicket?.ticket[0]?.supplier_order_id,
          order_id: this.selectTicket.ticket[0]?.order_id,
          refund_tickets: JSON.stringify(
            this.selectTicket?.ticket?.map(item =>{
              return {
                ticket_id: item?.ticket_id,
              }
            }))
        }
        mpx.showLoading()
        refundTicket(params)
          .then(({ data, success, message, code }) => {
            mpx.hideLoading()
            if (success) {
              if (code === '0') {
                this.closeRefundExplain()
                setStorage({
                  key: STORAGE_SUCCESS_INFO,
                  data: {
                    payType: 'refund',
                    title: ORDERSTATUSINFO?.refund?.title,
                    status: ORDERSTATUSINFO?.refund?.status,
                    content: data?.content
                  }
                })
                this.reload('refund')
              } else if (this.errLoginStatusArr.includes(code)) {
                Dialog.confirm({
                  title: '温馨提示',
                  message: '请登录与下单时一致的12306账号',
                  cancelButtonText: '知道了',
                  confirmButtonText: '去登录',
                  confirm: () => {
                    this.closeRefundExplain()
                    innerRouter.push(pagePath().LOGIN12306)
                  }
                })
              } else {
                this.refundRrrmsg = message ?? '退票失败，请稍后再试'
                this.showRefundErrorDialog = true
              }
            } else {
              this.showRequestErrorToast()
            }
          })
          .catch(() => {
            mpx.hideLoading()
            this.showRequestErrorToast()
          })
      },
      // 关闭退票失败错误弹窗
      closeRefundErrorDialog() {
        this.showRefundErrorDialog = false
      },
      // 获取 公告信息
      getServiceNotice() {
        if(this.baseInfo?.order_type === 1) {
          this.serviceNoticeList = [
            {
              "title": "该订单不支持在线退改，需至车站窗口办理",
              "noticeTitle": "温馨提示: ",
              "window_title": "温馨提示",
              "content_list": [
                {
                  "content": "1. 我们会全力为您出票，如果出票结果受余票变动及购票人数等因素影响，无法保证 100%购票成功\n2. 如果出票失败，票款及服务费会全部原路返还\n3. 退票/改签需至车站窗口办理，不支持网上在线退改\n4. 出票成功即享便捷购票服务，若退票，服务费不退还\n5. 便捷购票，享7*24 小时预定服务\n6. 因便捷购票线上无须核验身份，故无法提供除儿童票外的其他优惠票服务（学生、伤残、军人等），可正常出正价票"
                }
              ]
            }
          ]
          return
        }
        const params = {
          source_service: 'train',
          from_city: this.orderList?.[0]?.from_city_id,
          to_city: this.orderList?.[0]?.to_city_id
        }
        loadServiceNotice(params).then((res) => {
          if (res?.success && res?.code === '0') {
            this.serviceNoticeList = res?.data?.notice_list
          }
        })
      },
      // 交易记录
      async showDealDetail() {
        this.trackToPay('detail')
        if (this.showDealAlert) {
          this.showDealAlert = false
          return
        }
        await this.fetchDealDetail()
        this.showDealAlert = true
      },
      hideDealDetail() {
        this.showDealAlert = false
      },
      // 获取交易记录
      async fetchDealDetail() {
        const { order_id } = this.$mpxRoute.query
        await getDealDetail({ order_id })
          .then(res => {
            const { data, message, code, success } = res || {}
            if (success) {
              if (code == '0') {
                this.dealDetail = data
              } else {
                mpx.showToast({
                  title: message || LOAD_FAIL_CONTENT,
                  icon: 'none'
                })
              }
            } else {
              this.showRequestErrorToast()
            }
          })
          .catch((e) => {
            this.showRequestErrorToast()
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      showRequestErrorToast(message) {
        mpx.showToast({
          title: message || LOAD_FAIL_CONTENT,
          icon: 'error'
        })
      },
      // 时刻表
      closeSSI() {
        this.showStayInfo = false
      },
      showSSI(data) {
        const trainDetail = data?.detail || {}
        const train_code = trainDetail?.train_code || ''
        const train_no = trainDetail?.train_no || ''
        const info = {
          train_date: formatDate(trainDetail?.start_time),
          train_code: train_code,
          train_no: train_no,
          from_station_name: trainDetail?.from_station_name || '',
          to_station_name: trainDetail?.to_station_name || '',
        }
        this.stayInfo = info
        this.showStayInfo = true
      },
      // 联系客服
      toCustomerService() {
        const { order_id } = this.$mpxRoute.query || {}
        this.trackIssuedCk({
          module: 'cus_service',
          order_id,
          ticket_id: '',
          status: this.orderStatus
        })
        const source = is('passenger')
        ? 'app_ddcx_tohwd_im'
        : is('weixin')
          ? 'xcx_ddcx_paweq_im'
          : is('alipay')
            ? 'zfbxcx_ddcx_ngjel_im'
            : ''
        innerRouter.push(pagePath().HOMESERVICE, {
          order_id,
          source,
          actionType: 'help',
          orderId: order_id,
          from: this.from
        })
      },
      // 公告
      showTipsPop({ detail }) {
        this.noticeIndex = detail
        this.showNoticePop = true
      },
      hideDetailPop() {
        this.showNoticePop = false
      },
      scanScramblingTip() {
        this.scramblingExplainType = 'popup'
        this.scramblingExplainVisible = true
      },
      // 取消订单
      cancelOrder() {
        this.trackToPay('cancel')
        if(this.scrambling){
          this.scramblingExplainType = 'drawer'
          this.scramblingExplainVisible = true
          return
        }
        const remainingTime = this.remainingTime === 0
        if (remainingTime) {
          Dialog.confirm({
            title: '立即支付',
            message: '订单已失效，请点击【确定】重新订票',
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            cancel: () => {},
            confirm: async () => {
              innerRouter.replace(pagePath().HOME)
            }
          })
        } else {
          Dialog.confirm({
            title: '订单取消确认',
            message: '一天内三次申请车票成功后取消订单，当日不能继续购票',
            cancelButtonText: '确认取消',
            confirmButtonText: this.waitingPay ? '继续支付' : '继续等待',
            confirm: () => {},
            cancel: () => {
              this.canCancelOrder && this.fetchCanelOrder({
                successMsg: '取消成功'
              })
            }
          })
        }
      },
      // 确认取消
      fetchCanelOrder({ successMsg }) {
        if (isFastDoubleClick()) {
          return
        }
        mpx.showLoading()
        //待支付状态才能取消，此时要使用正在操作的订单id
        cancelOrder({
          order_id: this.baseInfo?.order_id,
          order_type: this.baseInfo?.order_type,
        })
          .then(({ data, success, code, message }) => {
            if (success) {
              if (code === '0') {
                mpx.showToast({
                  title: successMsg,
                  icon: 'success'
                })
                this.fetchTrainOrderDetailFunc()
              } else if(code === '7510' || code === '8000'){
                Dialog.confirm({
                  title: '温馨提示',
                  message: '请登录与下单时一致的12306账号',
                  cancelButtonText: '知道了',
                  confirmButtonText: '去登录',
                  confirm: () => {
                    this.closeRefundExplain()
                    innerRouter.push(pagePath().LOGIN12306)
                  }
                })
              } else {
                mpx.showModal({
                  title: '取消失败',
                  content: message,
                  showCancel: false,
                  confirmColor: '#1473FF',
                  confirmText: '确认'
                })
              }
            } else {
              this.showRequestErrorToast()
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      // 支付
      beforeMakePay() {
        if (isFastDoubleClick() || !this.canPay) {
          return
        }
        this.trackToPay('pay')
        this.hideDealDetail()
        const canPrepay = this.canPrepay ? 1: 0
        this.makePay(canPrepay)
      },
      makePay(pre_pay_type = 0) {
        makePay({
          order_id: this.baseInfo?.order_id,
          total_fee: this.feeInfo?.total_price,
          personal_pay: this.feeInfo?.personal_pay,
          pre_pay_type
        })
          .then(res => {
            const { data, message, code, success } = res || {}
            mpx.hideLoading()
            if (success) {
              if (code === '0' && data != null) {
                const { out_trade_id, reminder } = data
                this.onPayment(out_trade_id, reminder)
              } else if (code === '7003') {
                this.showRequestErrorToast(message)
                this.init()
              } else {
                this.showRequestErrorToast(message)
              }
            } else {
              this.showRequestErrorToast()
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      setSuccessPageInfo(order, ticket) {
        !ticket && (ticket = order?.tickets_info || [])
        this.selectTicket = {
          ticket: ticket,
          order_type: this.baseInfo?.order_type,
          status: this.orderStatus
        }
        const processingTicket = ticket.map(t=>{
          const { from_station_name, to_station_name } = order
          return { ...t, from_station_name, to_station_name }
        })
        setStorage({
          key: STORAGE_SELECT_TICKET,
          data: {
            ticket: processingTicket
          }
        })
      },
      // todo reminder 做啥的？
      onPayment(out_trade_id, reminder) {
        const { appid } = this.$mpxRoute.query || {}
        if (__mpx_mode__ === 'web') {
          const { token } = this
          const isChangeBeforePay = this.isChange
          // 存储改签结果页信息
          if(isChangeBeforePay) {
            this.setSuccessPageInfo(this.orderList?.[0])
          }
          const payType = this.canPrepay
            ? 'prepay'
            : isChangeBeforePay
              ? 'modify'
              : 'payed'
          const payRes = payMgr
            .pay({
              out_trade_id: out_trade_id,
              token: token,
              yks_appid: appid,
            })
          trackEvent('pay-callback', '排查--支付--收银台支付回调上报', { payRes: payRes })
          payRes.then((res) => {
              trackEvent('pay-result', '排查--支付--收银台成功回调上报', { payRes: res })
              const issuedDesc = this.couponInfo?.make_order_coupon_desc
              const issuingDesc = this.couponInfo?.order_pay_suc_coupon_desc
              // this.state 为原订单状态, 在改签 - 非预付（改签中）场景下, 不准确
              const couponDesc = this.statusName === '已出票' ? issuedDesc : issuingDesc
              setStorage({
                key: STORAGE_SUCCESS_INFO,
                data: {
                  payType,
                  title: ORDERSTATUSINFO?.[payType]?.title,
                  status: ORDERSTATUSINFO?.[payType]?.status,
                  desc:  ORDERSTATUSINFO?.[payType]?.desc,
                  couponInformBar: {
                    couponDesc,
                    couponInfo: this.couponInfo?.backward_coupon_info || {}
                  },
                  content: []
                }
              })
              const { order_id, from } = this.$mpxRoute.query || {}
              if( this.order_type === 2 ){
                this.fetchTrainOrderDetailFunc()
                trackEvent('scramble-success', '排查--支付--抢票下单成功回调上报', { order_type : 'scramble' })
              }else{
                const text = isChangeBeforePay ? 'change' : 'buy'
                this.reload(text)
                trackEvent('scramble-success', '排查--支付--其余票种下单成功回调上报', { order_type : text })
              }
            })
            .catch((err) => {
              console.log(err)
              trackEvent('scramble-success', '排查--支付--失败上报', { payRes: err })
            }).finally(()=>{
              trackEvent('pay-finish', '排查--支付完成')
            })
        }
      },
      // 预付
      prepayAction({ detail }) {
        this.trackPrepayPopup({
          event_id: 'userteam_train_concancel_paypop_ck',
          event_name: 'UT-火车票-订单详情页-支付弹窗-点击',
          params: {
            module: detail?.type === 'pay' ? 'now' : detail?.type
          }
        })
        this.prepayFooterVisible = true
        this.prepayPopupVisible = false
        if(detail?.type === 'pay') {
          this.onPrepay()
        }
      },
      onFooterPrepay() {
        this.trackPrepayPopup({
          event_id: 'userteam_train_concancel_paybutton_ck',
          event_name: 'UT-火车票-订单详情页-支付按钮-点击'
        })
        this.onPrepay()
      },
      onPrepay: debounce(function () {
        const type = this.isExemptionBooking ? 0 : 1
        this.makePay(type)
      }, 500, true),
      // 滚动中事件
      pageScroll({ detail: e }) {
        const { scrollTop } = e.detail
        this.recordScrollHeight = scrollTop
      },
      showAlternatePopup() {
        this.alternatePopupVisible = true
      },
      closeAlternatePopup() {
        this.alternatePopupVisible = false
      },
      closeScramblingExplain() {
        this.scramblingExplainVisible = false
      },
      confirmScramblingExplain() {
        this.scramblingExplainVisible = false
        this.canCancelOrder && this.fetchCanelOrder({
          successMsg: '提交成功'
        })
      },
      closeTicketOperate() {
        const info = {
          show: false,
          type: ''
        }
        this.setTikcetOperateDrawerStatus(info)
      },
      pageGoTo({ detail }) {
        const { type } = detail
        switch(type) {
          case 'rent':
            const url = isDdPassengerH5 ? "https://v.didi.cn/2M5jYx3" : "https://v.didi.cn/p/Po38Ldr"
            innerRouter.goTo(url)
            break
          case 'taxi':
            jumpToDachePage()
            break
          case 'customer':
            this.toCustomerService()
        }
      },
      reload(type = 'buy') {
        const text =
          type === 'buy' ? '支付成功' : type === 'change' ? '改签车票支付成功' : '退票申请提交成功'
        mpx.showToast({
          title: text,
          icon: 'success'
        })
        this.fetchTrainOrderDetailFunc()
        this.$forceUpdate()
      },
      // 获取
      getPreAccProgress() {
        const { order_id } = this.$mpxRoute.query || {}
        this.originalProgress = getStorage(SCRAMBLE_ACC_PRE_STATUS)?.[order_id] ?? 60
      },
      getPreSpeedStatus() {
        const { order_id } = this.$mpxRoute.query || {}
        this.originalStatus = getStorage(SCRAMBLE_SPEED_PRE_STATUS)?.[order_id] ?? 0
      },
      packageUpdate(){
        this.triggerPackagesPopup()
      },
      triggerPackagesPopup(){
        this.showPackagesPopup = !this.showPackagesPopup
      },
      payPackageRefresh(){
        this.feebackFlag =true
        this.fetchTrainOrderDetailFunc()
      },
      hideWorryFreeRightsDescDrawer() {
        this.worryFreeDescDrawerVisiable = false
      },
      showWorryFreeRightsDescDrawer() {
        this.worryFreeDescDrawerVisiable = true
      }
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      'order-info-list': '@/components/order-info-list',
      'stay-info-drawer': '@/components/stay-info-drawer',
      'order-state-head': './components/order-detail-head-state-card',
      'scrambling-order-head': './components/scrambling-order-head',
      'order-fee-head': './components/order-detail-total-fee-card',
      'warm-tips': '@/components/warm-tips',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'price-detail-info-alter': '@/components/price-detail-info-alter',
      'error-card': '@/components/error-card',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-pull-down-refresh': '@didi/es-mpx-ui/lib/pull-down-refresh/index',
      'pay-bottom-bar': './components/order-detail-pay-bottom-bar',
      'notice-popup': '@/material/block/notice/noticePopup',
      'coupon-card': './components/coupon-card',
      'prepay-popup': './components/prepay-popup',
      'refund-explain': '@/components/refund-explain',
      'offline-refund': './components/offline-refund',
      'scramble-contact-person': './components/scramble-contact-person',
      'scramble-info': './components/scramble-info',
      'train-rules': '@/pages/order/components/train-rules/index',
      'dual-channel': '@/components/dual-channel',
      'alternate-detail': '@/components/alternate-detail',
      'scrambling-explain': '@/components/scrambling-explain',
      'ticket-operate-drawer': './components/ticket-operate-drawer',
      'diamonds': '@/pages/home/components/diamonds',
      'transfer-order-card': './components/transfer-order-card',
      'accelerate-progress': './components/accelerate-progress',
      'worry-free-cancellation-bar': '@/components/worry-free-cancellation-bar',
      'rights-description-drawer': '@/pages/make-order/components/rights-description-drawer',
      'worry-free-cancellation-drawer': '@/pages/make-order/components/worry-free-cancellation-drawer',
      'packages-popup': './components/packages-popup',
      'feedback-popoup':'./components/feedback-popoup'
    }
  }
</script>
